import { AbstractUnsavedChangesService } from '@abstract-services/unsaved-changes/1.0/unsaved-changes.abstract.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesService implements AbstractUnsavedChangesService {
  private dialogResultSubject = new BehaviorSubject<boolean>(undefined);

  setResult(result: boolean) {
    this.dialogResultSubject.next(result);
  }

  getDialogResult(): Observable<boolean> {
    return this.dialogResultSubject.asObservable();
  }
}
